// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8ff0b224","239":"6e064a62","453":"fbc5a24f","455":"63975221"}[chunkId] + ".chunk.js";
};